import type { StepItemProps } from './interface';

export * from './generated';
export const StepItem = (props: StepItemProps) => null;
